import { Link } from "gatsby";
import PageSection from "@components/PageSection";
import React from "react";

interface IProps {
  lines: Queries.AvailableLineFragment | undefined | null;
}

interface ILineMap {
  [key: string]: {
    img: string;
    name: string;
  };
}

const AvailableLines = ({ lines }: IProps) => {
  if (!lines) return null;

  const AVAILABLE_LINE_MAP: ILineMap = {
    "heavy-body": { img: "/images/icons/productLine/heavy_body.png", name: "Heavy Body" },
    open: { img: "/images/icons/productLine/open.png", name: "OPEN" },
    "high-flow": { img: "/images/icons/productLine/high_flow.png", name: "High Flow" },
    fluid: { img: "/images/icons/productLine/fluid.png", name: "Fluid" },
    "soflat": { img: "/images/icons/productLine/soflat.png", name: "SoFlat" },
  };

  const available_lines = lines.products_colors.flatMap((pc) => {
    if (!pc?.product) return [];

    const groups = pc.product.product_groups
      .filter((pg) => pg.product_group_type?.type_name === "filter bar")
      .filter((pg) => AVAILABLE_LINE_MAP[pg.slug]);

    if (groups.length > 0) return [{ productName: pc.product.product_name, productSlug: pc.product.slug, lineSlug: groups[0].slug }];

    return [];
  });

  return available_lines.length > 0 ? (
    <PageSection sectionName="Available Lines">
      <div className="flex gap-2">
        {available_lines?.map((line) => {
          const lineLookupData = AVAILABLE_LINE_MAP[line?.lineSlug ?? ""];

          if (!lineLookupData) return null;

          return (
            <Link
              to={`/products/${line?.productSlug}`}
              key={line?.lineSlug}
            >
              <div className="flex flex-col place-items-center w-20">
                <img src={lineLookupData.img} alt={lineLookupData.name} />
                <p className="underline text-center">{lineLookupData.name}</p>
              </div>
            </Link>
          );
        })}
     </div>
    </PageSection>
  ) : null;
};

export default AvailableLines;
